// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { getOrdersDataView } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import constants from "@store/constants";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/OrderHistory/Handlers/UpdateDraftParameter";
import debounce from "lodash/debounce";
import { useCallback } from "react";

export const useOrderHistoryState = () => {
    return useAppSelector(state => state.greif.pages.orderHistory);
};

export const useOrderHistoryDataView = (parameter?: GetOrdersApiParameter) => {
    return useAppSelector(state => {
        return getOrdersDataView(state, parameter || state.greif.pages.orderHistory.parameter);
    });
};

export const useOrderHistoryDebouncedUpdateDraftParameter = () => {
    const dispatch = useAppDispatch();

    return useCallback(
        debounce(
            (parameter: GetOrdersApiParameter) => dispatch(updateDraftParameter(parameter)),
            constants.searchDebounceDelay,
        ),
        [],
    );
};
